<template>
  <div class="baby_manage_tabs">
    <store-good-list v-show="type === 'storeGoodList'" @tabschange="tabschange"></store-good-list>
    <store-link-list v-show="type === 'storeLinkList'" @tabschange="tabschange"></store-link-list>
    <cannot-link-list v-show="type === 'cannotLinkList'" @tabschange="tabschange"></cannot-link-list>
  </div>
</template>

<script>
  import StoreGoodList from './store-good-list';
  import StoreLinkList from './store-link-list';
  import CannotLinkList from './cannot-link-list';

  export default {
    name: 'baby-management',
    components: {StoreGoodList, StoreLinkList, CannotLinkList},
    data() {
      return {
        tabsList: [
          {name: '店铺货品列表', value: 'storeGoodList'},
          {name: '店铺链接列表', value: 'storeLinkList'},
          {name: '无法识别链接列表', value: 'cannotLinkList'}
        ], // tabs列表
        type: 'storeGoodList', // 显示类型
        overflowY: 'auto'
      }
    },
    methods: {
      // tabs切换路由跳转
      tabsChange(type) {
        this.type = type;
      },

      tabschange(e) {
        // console.log(e);
        this.type = e.type;
        this.$router.push({
          path: '/home/baby_mg',
          query: {
            type: this.type
          }
        });
      }
    },
    created() {
      if (this.$route.query['type']) {
        console.log(this.$route.query['type']);
        this.type = this.$route.query['type'];
        this.$router.push({
          path: '/home/baby_mg',
          query: {
            type: this.$route.query['type']
          }
        });
      }
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.type = 'storeGoodList';
        this.storeGoodListRefresh = true;
        this.storeLinkListRefresh = true;
        this.cannotLinkListRefresh = true;
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/css/home-view";
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/baby-management/baby-management.vue